import STATE_LIST from './data/states.json';
export const STATES = STATE_LIST.map(item => ({
    countryCode: item.countryCode,
    key: item.state,
    label: `global.state.${item.state}`,
}));
